import { useTranslation } from "react-i18next";
import Widget from '../../widget';
import { sections } from './config';
import Style from '../supply-chain-details/style';
import { getNumberValue } from "../../../../helpers/Number";
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { LoadingOutlined } from "@ant-design/icons";

export default function Activities({
  data = {},
  getOption = () => { },
  tradeData = {},
  loading,
}) {
  const { t } = useTranslation();

  return (
    <Widget
      title={t('Supply Chain Details')}
    >
      <Style className="default-content">
        <div className="default-section">
          <label className="title">{t('Products')}</label>
          {loading ? (
            <div className="flex">
              <LoadingOutlined className="loader-1" />
            </div>
          ) : (
            <div className="wrap">
              {(data.products && data.products.length) ? data.products.map((p, i) => (
                <div key={`products-${p}-${i}`} className={`tag mineral ${p}`}>{getOption('mineralOptions', p)}</div>
              )) : (
                <div className="tag">--</div>
              )}
            </div>
          )}
        </div>

        <div className="sections">
          {sections.map((s, i) => (
            <div
              className={formatClassname(['section', i !== 2 && 'with-border', i === 0 && 'first'])}
              key={`section-${s.key}-${i}`}
            >
              <div className="item label">
                <label>{t(s.label)}</label>
              </div>
              <div className="item value">
                <label>
                  {loading ? (
                    <div>
                      <LoadingOutlined className="loader-2" />
                    </div>
                  ) : getNumberValue((tradeData[s.key] || []).length)}
                </label>
              </div>
            </div>
          ))}
        </div>
      </Style>
    </Widget>
  )
}
